const KEY = 'mi_admin_session';
const TTL_MS = 30 * 60 * 1000;

export function unlockAdminSession(): void {
  localStorage.setItem(KEY, JSON.stringify({ unlockedAt: Date.now() }));
}

export function lockAdminSession(): void {
  localStorage.removeItem(KEY);
}

export function isAdminSessionValid(): boolean {
  const raw = localStorage.getItem(KEY);
  if (!raw) return false;
  try {
    const { unlockedAt } = JSON.parse(raw) as { unlockedAt: number };
    return Date.now() - unlockedAt <= TTL_MS;
  } catch {
    return false;
  }
}
